// This file was generated by https://github.com/redbubble/design/blob/master/scripts/generateIcons.js
import React from 'react';
import Icon from '../Icon';

const MinusLargeIcon = props => <Icon {...props} dangerouslySetIcon={'<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M5 11h14a1 1 0 010 2H5a1 1 0 010-2z"/></svg>'} />;

MinusLargeIcon.displayName = 'MinusLargeIcon';

export default MinusLargeIcon;
